/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Header_SubtitleInputs */



/**
* | output |
* | --- |
* | "EU AI Act governance that scales with you. Start free, upgrade when you need more models, more storage, or team controls." |
*
* @param {Pricing_Header_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pricing_header_subtitle = /** @type {((inputs?: Pricing_Header_SubtitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Header_SubtitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("EU-KI-Verordnung-Governance, die mit Ihnen wächst. Starten Sie kostenlos und erweitern Sie bei Bedarf um mehr Modelle, mehr Speicher oder Teamfunktionen.")
	return /** @type {LocalizedString} */ ("EU AI Act governance that scales with you. Start free, upgrade when you need more models, more storage, or team controls.")
});